export const countriesData = [
  {
    flagUrl: "qatarFlag",
    flagName: "flagQatar",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #ffffff, #63a194)",
    teamName: "Qatar is",
    teamEmoji: "qatar",
    teamShield: "",
    platformColor: "#ffffff",
    backgroundColor: "#7e1331",
    shirtColor: "#6d1f2c",
    shortsColor: "#af1924",
    socksColor: "#af1924",
    tennisColor: "#7d8471",
    shirtNumber: "",
    hairColor: "#1e1b1d",
    skinColor: "#93613c",
    shirtDetailsColor: "#af1924",
    tennisDetailsColor: "#ffffff",
    primaryLightColor: "#ffeff4",
    secondaryLightColor: "#ff9c9c",
    ambientLightColor: "#ff9cb8",
    pointerColor1: "#ffffff",
    pointerColor2: "#7e1331",
    pointerColor3: "#252525",
    textColor: "#ffffff",
    textNumber: "10",
    index: 0,
    dataCenterX: 0,
    dataCenterY: 0,
  },
  {
    flagUrl: "ecuadorFlag",
    flagName: "flagEcuador",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #002154, #e4073a)",
    teamName: "Ecuador is",
    teamEmoji: "ecuador",
    teamShield: "",
    platformColor: "#002051",
    backgroundColor: "#ffea63",
    shirtColor: "#f5ee55",
    shortsColor: "#072e73",
    socksColor: "#072e73",
    tennisColor: "#7FB5B5",
    shirtNumber: "",
    hairColor: "#000000",
    skinColor: "#553216",
    shirtDetailsColor: "#072e73",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#f7d600",
    secondaryLightColor: "#ff0000",
    ambientLightColor: "#f7d600",
    pointerColor1: "#e4073a",
    pointerColor2: "#002154",
    pointerColor3: "#ffcd00",
    textColor: "#304162",
    textNumber: "13",
    index: 1,
    dataCenterX: 0.2,
    dataCenterY: 0,
  },
  {
    flagUrl: "senegalFlag",
    flagName: "flagSenegal",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #00843f, #fcef42, #e31c22)",
    teamName: "Senegal is",
    teamEmoji: "senegal",
    platformColor: "#ffb600",
    teamShield: "",
    backgroundColor: "#fefefe",
    shirtColor: "#f9f9f9",
    shortsColor: "#f9f9f9",
    socksColor: "#f9f9f9",
    tennisColor: "#FF7514",
    shirtNumber: "",
    hairColor: "#000000",
    skinColor: "#301e10",
    shirtDetailsColor: "#07443d",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#e31c22",
    secondaryLightColor: "#00843f",
    ambientLightColor: "#fcef42",
    pointerColor1: "#e63f23",
    pointerColor2: "#ffdb00",
    pointerColor3: "#11a234",
    textColor: "#05907c",
    textNumber: "10",
    index: 2,
    dataCenterX: 0.6,
    dataCenterY: 0,
  },
  {
    flagUrl: "netherlandFlag",
    flagName: "flagNetherlands",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #ffffff, #dedede)",
    teamName: " The Netherlands are",
    teamEmoji: "netherlands",
    teamShield: "",
    platformColor: "#ff5900",
    backgroundColor: "#f26b20",
    shirtColor: "#ff601b",
    shortsColor: "#ff601b",
    socksColor: "#ff601b",
    tennisColor: "#2F4538",
    shirtNumber: "",
    hairColor: "#5a3825",
    skinColor: "#eec693",
    shirtDetailsColor: "#252525",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#ff601b",
    secondaryLightColor: "#2b79ef",
    ambientLightColor: "#ff601b",
    pointerColor1: "#000000",
    pointerColor2: "#ffffff",
    pointerColor3: "#f26b20",
    textColor: "#252525",
    textNumber: "21",
    index: 3,
    dataCenterX: 0.4,
    dataCenterY: 0,
  },
  {
    flagUrl: "englandFlag",
    flagName: "flagEngland",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #ffffff, #e91f29)",
    teamName: "England is",
    teamEmoji: "england",
    teamShield: "",
    platformColor: "#2954a6",
    backgroundColor: "#23236f",
    shirtColor: "#ffffff",
    shortsColor: "#2a57ab",
    socksColor: "#ffffff",
    tennisColor: "#B32821",
    shirtNumber: "",
    hairColor: "#a5581d",
    skinColor: "#b17c7e",
    shirtDetailsColor: "#000040",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#aec6f2",
    secondaryLightColor: "#e91f29",
    ambientLightColor: "#aec6f2",
    pointerColor1: "#ffffff",
    pointerColor2: "#2a57ab",
    pointerColor3: "#e91f29",
    textColor: "#1a1f42",
    textNumber: "9",
    index: 4,
    dataCenterX: 0.8,
    dataCenterY: 0,
  },
  {
    flagUrl: "iranFlag",
    flagName: "flagIran",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #ffffff, #d90000)",
    teamName: "Iran is",
    teamEmoji: "iran",
    teamShield: "",
    platformColor: "#ffffff",
    backgroundColor: "#3cc75c",
    shirtColor: "#f7f7f7",
    shortsColor: "#f7f7f7",
    socksColor: "#22993e",
    tennisColor: "#909090",
    shirtNumber: "5",
    hairColor: "#252525",
    skinColor: "#885633",
    shirtDetailsColor: "#d20000",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#ade2ba",
    secondaryLightColor: "#61beff",
    ambientLightColor: "#ade2ba",
    pointerColor1: "#d90000",
    pointerColor2: "#ffffff",
    pointerColor3: "#239e40",
    textColor: "#cb1e2b",
    textNumber: "6",
    index: 5,
    dataCenterX: 1.0,
    dataCenterY: 0,
  },
  {
    flagUrl: "usaFlag",
    flagName: "flagUsa",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #1f2641, #1f2641, #ffffff)",
    teamName: "The United States are",
    teamEmoji: "usa",
    teamShield: "",
    platformColor: "#25346c",
    backgroundColor: "#ba2533",
    shirtColor: "#ffffff",
    shortsColor: "#1f2641",
    socksColor: "#ba2533",
    tennisColor: "#474A51",
    shirtNumber: "",
    hairColor: "#252525",
    skinColor: "#edbf84",
    shirtDetailsColor: "#1f2641",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#f2a2aa",
    secondaryLightColor: "#0006ff",
    ambientLightColor: "#f2a2aa",
    pointerColor1: "#1f2641",
    pointerColor2: "#ba2533",
    pointerColor3: "#ffffff",
    textColor: "#00226f",
    textNumber: "10",
    index: 6,
    dataCenterX: 0,
    dataCenterY: 0.2,
  },
  {
    flagUrl: "walesFlag",
    flagName: "flagWales",
    mainColor: "",
    secondaryColor: "",
    gradientColor:
      "linear-gradient(to right, #ffffff, #ffffff, #ae2630, #174a3f)",
    teamName: "Wales is",
    teamEmoji: "wales",
    teamShield: "",
    platformColor: "#ae2630",
    backgroundColor: "#0ad150",
    shirtColor: "#ed1b23",
    shortsColor: "#ffffff",
    socksColor: "#ed1b23",
    tennisColor: "#A03472",
    shirtNumber: "",
    hairColor: "#491b01",
    skinColor: "#edbf84",
    shirtDetailsColor: "#eda814",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#e8a0ac",
    secondaryLightColor: "#00b13f",
    ambientLightColor: "#e8a0ac",
    pointerColor1: "#174a3f",
    pointerColor2: "#ae2630",
    pointerColor3: "#cf1e26",
    textColor: "#ffffff",
    textNumber: "11",
    index: 7,
    dataCenterX: 0.2,
    dataCenterY: 0.2,
  },
  {
    flagUrl: "argentinaFlag",
    flagName: "flagArgentina",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #ffffff, #ffffff, #42a1d5)",
    teamName: "Argentina is",
    teamEmoji: "argentina",
    teamShield: "",
    platformColor: "#ffffff",
    backgroundColor: "#a6e0ff",
    shirtColor: "#42a1d5",
    shortsColor: "#173d69",
    socksColor: "#ffffff",
    tennisColor: "#26252D",
    shirtNumber: "",
    hairColor: "#1e1b1d",
    skinColor: "#b17c7e",
    shirtDetailsColor: "#000000",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#a6e0ff",
    secondaryLightColor: "#ffd56c",
    ambientLightColor: "#c6ebff",
    pointerColor1: "#ffffff",
    pointerColor2: "#173d69",
    pointerColor3: "#42a1d5",
    textColor: "#13131f",
    textNumber: "10",
    index: 8,
    dataCenterX: 0.4,
    dataCenterY: 0.2,
  },
  {
    flagUrl: "saudiArabiaFlag",
    flagName: "flagSaudiArabia",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #ffffff, #7dc7ae)",
    teamName: "Saudi Arabia is",
    teamEmoji: "saudiArabia",
    teamShield: "",
    platformColor: "#3ea382",
    backgroundColor: "#1c864c",
    shirtColor: "#ffffff",
    shortsColor: "#7dc7ae",
    socksColor: "#125b33",
    tennisColor: "#922B3E",
    shirtNumber: "",
    hairColor: "#252525",
    skinColor: "#8b5b35",
    shirtDetailsColor: "#7dc7ae",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#ffffff",
    secondaryLightColor: "#882fcb",
    ambientLightColor: "#a9efd7",
    pointerColor1: "#ffffff",
    pointerColor2: "#7dc7ae",
    pointerColor3: "#125b33",
    textColor: "#1c9b62",
    textNumber: "10",
    index: 9,
    dataCenterX: 0.6,
    dataCenterY: 0.2,
  },
  {
    flagUrl: "mexicoFlag",
    flagName: "flagMexico",
    mainColor: "",
    secondaryColor: "",
    gradientColor:
      "linear-gradient(to right, #ffffff, #ffffff, #00933b, #f5313d)",
    teamName: "Mexico is",
    teamEmoji: "mexico",
    teamShield: "",
    platformColor: "#ffffff",
    backgroundColor: "#16de66",
    shirtColor: "#00933b",
    shortsColor: "#ffffff",
    socksColor: "#f5313d",
    tennisColor: "#3E5F8A",
    shirtNumber: "",
    hairColor: "#1e1b1d",
    skinColor: "#93613c",
    shirtDetailsColor: "#f5313d",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#fcd0d3",
    secondaryLightColor: "#00933b",
    ambientLightColor: "#fcd0d3",
    pointerColor1: "#f5313d",
    pointerColor2: "#ffffff",
    pointerColor3: "#00933b",
    textColor: "#ffffff",
    textNumber: "22",
    index: 10,
    dataCenterX: 0.8,
    dataCenterY: 0.2,
  },
  {
    flagUrl: "polandFlag",
    flagName: "flagPoland",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #ffffff, #ffffff, #db133c)",
    teamName: "Poland is",
    teamEmoji: "poland",
    teamShield: "poland",
    platformColor: "#9d001f",
    backgroundColor: "#f7f7f7",
    shirtColor: "#f7f7f7",
    shortsColor: "#f7f7f7",
    socksColor: "#f7f7f7",
    tennisColor: "#317F43",
    shirtNumber: "",
    hairColor: "#1e1b1d",
    skinColor: "#b17c7e",
    shirtDetailsColor: "#d4123a",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#f2617e",
    secondaryLightColor: "#ffb600",
    ambientLightColor: "#efaab8",
    pointerColor1: "#db133c",
    pointerColor2: "#ffffff",
    pointerColor3: "#252525",
    textColor: "#e52723",
    textNumber: "9",
    index: 11,
    dataCenterX: 1.0,
    dataCenterY: 0.2,
  },
  {
    flagUrl: "franceFlag",
    flagName: "flagFrance",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #ffffff, #17538b, #ec2938)",
    teamName: "France is",
    teamEmoji: "france",
    teamShield: "france",
    platformColor: "#165087",
    backgroundColor: "#202f4d",
    shirtColor: "#202f4d",
    shortsColor: "#ffffff",
    socksColor: "#ec2938",
    tennisColor: "#6C7059",
    shirtNumber: "",
    hairColor: "#1e1b1d",
    skinColor: "#b17c7e",
    shirtDetailsColor: "#17538b",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#d8eafc",
    secondaryLightColor: "#ec2938",
    ambientLightColor: "#d8eafc",
    pointerColor1: "#ec2938",
    pointerColor2: "#17538b",
    pointerColor3: "#202f4d",
    textColor: "#ffffff",
    textNumber: "10",
    index: 12,
    dataCenterX: 0,
    dataCenterY: 0.4,
  },
  {
    flagUrl: "australiaFlag",
    flagName: "flagAustralia",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #00833c, #ffcc00)",
    teamName: "Australia is",
    teamEmoji: "australia",
    teamShield: "",
    platformColor: "#007f3a",
    backgroundColor: "#ffdd53",
    shirtColor: "#ffcc00",
    shortsColor: "#00833c",
    socksColor: "#ffcc00",
    tennisColor: "#3E5F8A",
    shirtNumber: "",
    hairColor: "#1e1b1d",
    skinColor: "#b17c7e",
    shirtDetailsColor: "#00833c",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#fce691",
    secondaryLightColor: "#882fcb",
    ambientLightColor: "#fce691",
    pointerColor1: "#00833c",
    pointerColor2: "#ffcc00",
    pointerColor3: "#ffffff",
    textColor: "#00833c",
    textNumber: "8",
    index: 13,
    dataCenterX: 0.2,
    dataCenterY: 0.4,
  },
  {
    flagUrl: "denmarkFlag",
    flagName: "flagDenmark",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #ffffff, #ffffff, #cc171d)",
    teamName: "Denmark is",
    teamEmoji: "denmark",
    teamShield: "",
    platformColor: "#ffffff",
    backgroundColor: "#ff2e35",
    shirtColor: "#c6161c",
    shortsColor: "#c6161c",
    socksColor: "#c6161c",
    tennisColor: "#343E40",
    shirtNumber: "",
    hairColor: "#9d6828",
    skinColor: "#b17c7e",
    shirtDetailsColor: "#ffffff",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#ffe4e5",
    secondaryLightColor: "#009fff",
    ambientLightColor: "#ffe4e5",
    pointerColor1: "#ffffff",
    pointerColor2: "#cc171d",
    pointerColor3: "#252525",
    textColor: "#ffffff",
    textNumber: "10",
    index: 14,
    dataCenterX: 0.4,
    dataCenterY: 0.4,
  },
  {
    flagUrl: "tunisiaFlag",
    flagName: "flagTunisia",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #ffffff, #ffffff, #e70012)",
    teamName: "Tunisia is",
    teamEmoji: "tunisia",
    teamShield: "",
    platformColor: "#ffffff",
    backgroundColor: "#e70012",
    shirtColor: "#e70012",
    shortsColor: "#e70012",
    socksColor: "#e70012",
    tennisColor: "#015D52",
    shirtNumber: "",
    hairColor: "#000000",
    skinColor: "#885633",
    shirtDetailsColor: "#e70012",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#ff97a0",
    secondaryLightColor: "#e70012",
    ambientLightColor: "#ff97a0",
    pointerColor1: "#ffffff",
    pointerColor2: "#e70012",
    pointerColor3: "#252525",
    textColor: "#ffffff",
    textNumber: "9",
    index: 15,
    dataCenterX: 0.6,
    dataCenterY: 0.4,
  },
  {
    flagUrl: "spainFlag",
    flagName: "flagSpain",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #fbb407, #fbb407, #01124f)",
    teamName: "Spain is",
    teamEmoji: "spain",
    teamShield: "",
    platformColor: "#b17f00",
    backgroundColor: "#c7151b",
    shirtColor: "#8b0d11",
    shortsColor: "#01124f",
    socksColor: "#8b0d11",
    tennisColor: "#332F2C",
    shirtNumber: "",
    hairColor: "#330f05",
    skinColor: "#b17c7e",
    shirtDetailsColor: "#fbb407",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#ffd771",
    secondaryLightColor: "#2c4dc4",
    ambientLightColor: "#ffd771",
    pointerColor1: "#fbb407",
    pointerColor2: "#01124f",
    pointerColor3: "#8b0d11",
    textColor: "#fbb407",
    textNumber: "10",
    index: 16,
    dataCenterX: 0.8,
    dataCenterY: 0.4,
  },
  {
    flagUrl: "costaRicaFlag",
    flagName: "flagCostaRica",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #ec1d25, #ebc17d, #ffffff)",
    teamName: "Costa Rica is",
    teamEmoji: "costaRica",
    teamShield: "",
    platformColor: "",
    backgroundColor: "#125aa7",
    shirtColor: "#c80a20",
    shortsColor: "#113aa5",
    socksColor: "#ecf2ea",
    tennisColor: "#403A3A",
    shirtNumber: "",
    hairColor: "#252525",
    skinColor: "#885633",
    shirtDetailsColor: "#113aa5",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#cbdef2",
    secondaryLightColor: "#fc6678",
    ambientLightColor: "#cbdef2",
    pointerColor1: "#ec1d25",
    pointerColor2: "#132361",
    pointerColor3: "#ffffff",
    textColor: "#ffffff",
    textNumber: "14",
    index: 17,
    dataCenterX: 1.0,
    dataCenterY: 0.4,
  },
  {
    flagUrl: "germanyFlag",
    flagName: "flagGermany",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #000000, #d60f16, #b0a55e)",
    teamName: "Germany is",
    teamEmoji: "germany",
    teamShield: "",
    platformColor: "#ffffff",
    backgroundColor: "#ffffff",
    shirtColor: "#ffffff",
    shortsColor: "#000000",
    socksColor: "#ffffff",
    tennisColor: "#C7B446",
    shirtNumber: "",
    hairColor: "#3f2210",
    skinColor: "#b17c7e",
    shirtDetailsColor: "#000000",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#f7c800",
    secondaryLightColor: "#ff8686",
    ambientLightColor: "#f7c800",
    pointerColor1: "#000000",
    pointerColor2: "#d60f16",
    pointerColor3: "#ffffff",
    textColor: "#000000",
    textNumber: "6",
    index: 18,
    dataCenterX: 0,
    dataCenterY: 0.6,
  },
  {
    flagUrl: "japanFlag",
    flagName: "flagJapan",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #e30016, #ffffff, #000454)",
    teamName: "Japan is",
    teamEmoji: "japan",
    teamShield: "",
    platformColor: "#b70012",
    backgroundColor: "#2d3a6f",
    shirtColor: "#22316c",
    shortsColor: "#ffffff",
    socksColor: "#22316c",
    tennisColor: "#6D3F5B",
    shirtNumber: "",
    hairColor: "#1e1b1d",
    skinColor: "#b17c7e",
    shirtDetailsColor: "#ffffff",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#b0d3e8",
    secondaryLightColor: "#e30016",
    ambientLightColor: "#b0d3e8",
    pointerColor1: "#e30016",
    pointerColor2: "#ffffff",
    pointerColor3: "#000454",
    textColor: "#ffffff",
    textNumber: "10",
    index: 19,
    dataCenterX: 0.2,
    dataCenterY: 0.6,
  },
  {
    flagUrl: "belgiumFlag",
    flagName: "flagBelgium",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #e30512, #000000, #b49c56)",
    teamName: "Belgium is",
    teamEmoji: "belgium",
    teamShield: "",
    platformColor: "#c70c19",
    backgroundColor: "#ffd500",
    shirtColor: "#e30512",
    shortsColor: "#e30512",
    socksColor: "#e30512",
    tennisColor: "#1F3438",
    shirtNumber: "",
    hairColor: "#9d6828",
    skinColor: "#edbf84",
    shirtDetailsColor: "#ffd500",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#ffbcc1",
    secondaryLightColor: "#ffdc2b",
    ambientLightColor: "#ffbcc1",
    pointerColor1: "#e30512",
    pointerColor2: "#ffd500",
    pointerColor3: "#000000",
    textColor: "#ffd500",
    textNumber: "7",
    index: 20,
    dataCenterX: 0.4,
    dataCenterY: 0.6,
  },
  {
    flagUrl: "canadaFlag",
    flagName: "flagCanada",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #c4281b, #c4281b, #000000)",
    teamName: "Canada is",
    teamEmoji: "canada",
    teamShield: "",
    platformColor: "",
    backgroundColor: "#ffffff",
    shirtColor: "#c6281d",
    shortsColor: "#c6281d",
    socksColor: "#c6281d",
    tennisColor: "#606E8C",
    shirtNumber: "",
    hairColor: "#000000",
    skinColor: "#301e10",
    shirtDetailsColor: "#c6281d",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#ffd9d6",
    secondaryLightColor: "#ffffff",
    ambientLightColor: "#ffd9d6",
    pointerColor1: "#c4281b",
    pointerColor2: "#ffffff",
    pointerColor3: "#000000",
    textColor: "#ffffff",
    textNumber: "19",
    index: 21,
    dataCenterX: 0.6,
    dataCenterY: 0.6,
  },
  {
    flagUrl: "morocoFlag",
    flagName: "flagMorocco",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #e40011, #ffffff, #17a275)",
    teamName: "Morocco is",
    teamEmoji: "morocco",
    teamShield: "",
    platformColor: "#9a000a",
    backgroundColor: "#17a275",
    shirtColor: "#e40011",
    shortsColor: "#17a275",
    socksColor: "#e40011",
    tennisColor: "#E4A010",
    shirtNumber: "",
    hairColor: "#1e1b1d",
    skinColor: "#885633",
    shirtDetailsColor: "#17a275",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#9ed8c5",
    secondaryLightColor: "#ffbec2",
    ambientLightColor: "#9ed8c5",
    pointerColor1: "#ffffff",
    pointerColor2: "#e40011",
    pointerColor3: "#17a275",
    textColor: "#17a275",
    textNumber: "2",
    index: 22,
    dataCenterX: 0.8,
    dataCenterY: 0.6,
  },
  {
    flagUrl: "croatiaFlag",
    flagName: "flagCroatia",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #ec1b24, #ffffff, #0457a2)",
    teamName: "Croatia is",
    teamEmoji: "croatia",
    teamShield: "",
    platformColor: "#deb66f",
    backgroundColor: "#0055a0",
    shirtColor: "#ec1b24",
    shortsColor: "#ffffff",
    socksColor: "#0457a2",
    tennisColor: "#3E3B32",
    shirtNumber: "",
    hairColor: "#3f2210",
    skinColor: "#b17c7e",
    shirtDetailsColor: "#ec1b24",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#f8c4c6",
    secondaryLightColor: "#ffffff",
    ambientLightColor: "#f8c4c6",
    pointerColor1: "#ec1b24",
    pointerColor2: "#ffffff",
    pointerColor3: "#deb66f",
    textColor: "#35528c",
    textNumber: "10",
    index: 23,
    dataCenterX: 1.0,
    dataCenterY: 0.6,
  },
  {
    flagUrl: "brazilFlag",
    flagName: "flagBrazil",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #183374, #183374, #18ae46)",
    teamName: "Brazil is",
    teamEmoji: "brazil",
    teamShield: "",
    platformColor: "#108031",
    backgroundColor: "#ffdb01",
    shirtColor: "#ffdb01",
    shortsColor: "#183374",
    socksColor: "#ffffff",
    tennisColor: "#A03472",
    shirtNumber: "",
    hairColor: "#1e1b1d",
    skinColor: "#885633",
    shirtDetailsColor: "#18ae46",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#e5dcad",
    secondaryLightColor: "#60f800",
    ambientLightColor: "#f2e38b",
    pointerColor1: "#18ae46",
    pointerColor2: "#ffdb01",
    pointerColor3: "#183374",
    textColor: "#18ae46",
    textNumber: "10",
    index: 24,
    dataCenterX: 0,
    dataCenterY: 0.8,
  },
  {
    flagUrl: "serbiaFlag",
    flagName: "flagSerbia",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #ffffff, #b49d59, #b49d59)",
    teamName: "Serbia is",
    teamEmoji: "serbia",
    teamShield: "",
    platformColor: "#f7f7f7",
    backgroundColor: "#b62e3d",
    shirtColor: "#b62e3d",
    shortsColor: "#b62e3d",
    socksColor: "#b62e3d",
    tennisColor: "#C1876B",
    shirtNumber: "",
    hairColor: "#1e1b1d",
    skinColor: "#b17c7e",
    shirtDetailsColor: "#ffffff",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#fffdf1",
    secondaryLightColor: "#b9e8ad",
    ambientLightColor: "#fffced",
    pointerColor1: "#b49d59",
    pointerColor2: "#ffffff",
    pointerColor3: "#b62e3d",
    textColor: "#ffffff",
    textNumber: "3",
    index: 25,
    dataCenterX: 0.2,
    dataCenterY: 0.8,
  },
  {
    flagUrl: "switzerlandFlag",
    flagName: "flagSwitzerland",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #ffffff, #730c13, #ff0000)",
    teamName: "Switzerland is",
    teamEmoji: "switzerland",
    teamShield: "",
    platformColor: "#b70000",
    backgroundColor: "#ffffff",
    shirtColor: "#ec0b19",
    shortsColor: "#ffffff",
    socksColor: "#ec0b19",
    tennisColor: "#F3A505",
    shirtNumber: "",
    hairColor: "#1e1b1d",
    skinColor: "#b17c7e",
    shirtDetailsColor: "#ffffff",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#ffdfe1",
    secondaryLightColor: "#ffffff",
    ambientLightColor: "#ffaeb3",
    pointerColor1: "#ffffff",
    pointerColor2: "#730c13",
    pointerColor3: "#ff0000",
    textColor: "#ffffff",
    textNumber: "10",
    index: 26,
    dataCenterX: 0.6,
    dataCenterY: 0.8,
  },
  {
    flagUrl: "cameronFlag",
    flagName: "flagCameroon",
    mainColor: "",
    secondaryColor: "",
    gradientColor:
      " linear-gradient(to right, #000000, #000000, #fad81b, #ec1b24)",
    teamName: "Cameroon is",
    teamEmoji: "cameroon",
    teamShield: "",
    platformColor: "#dbbb03",
    backgroundColor: "#44b151",
    shirtColor: "#46994f",
    shortsColor: "#ec1b24",
    socksColor: "#fad81b",
    tennisColor: "#8B8C7A",
    shirtNumber: "",
    hairColor: "#000000",
    skinColor: "#623a17",
    shirtDetailsColor: "#fad81b",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#fad81b",
    secondaryLightColor: "#ff4952",
    ambientLightColor: "#ffe96c",
    pointerColor1: "#46994f",
    pointerColor2: "#ec1b24",
    pointerColor3: "#fad81b",
    textColor: "#ec1b24",
    textNumber: "13",
    index: 27,
    dataCenterX: 0.4,
    dataCenterY: 0.8,
  },
  {
    flagUrl: "portugalFlag",
    flagName: "flagPortugal",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #0d6937, #0d6937, #000000)",
    teamName: "Portugal is",
    teamEmoji: "portugal",
    teamShield: "",
    platformColor: "#0d6635",
    backgroundColor: "#b11e28",
    shirtColor: "#e32517",
    shortsColor: "#0d6937",
    socksColor: "#0d6937",
    tennisColor: "#6D3F5B",
    shirtNumber: "",
    hairColor: "#1e1b1d",
    skinColor: "#b17c7e",
    shirtDetailsColor: "#0d6937",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#89ffbe",
    secondaryLightColor: "#00ff73",
    ambientLightColor: "#d4ffe7",
    pointerColor1: "#0d6937",
    pointerColor2: "#e32517",
    pointerColor3: "#d3bf83",
    textColor: "#0d6937",
    textNumber: "7",
    index: 28,
    dataCenterX: 0.8,
    dataCenterY: 0.8,
  },
  {
    flagUrl: "ghanaFlag",
    flagName: "flagGhana",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #009434, #d40023, #000000)",
    teamName: "Ghana is",
    teamEmoji: "ghana",
    teamShield: "",
    platformColor: "#ffe400",
    backgroundColor: "#fcd20f",
    shirtColor: "#ffffff",
    shortsColor: "#ffffff",
    socksColor: "#ffffff",
    tennisColor: "#382C1E",
    shirtNumber: "",
    hairColor: "#1e1b1d",
    skinColor: "#301e10",
    shirtDetailsColor: "#009434",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#efc300",
    secondaryLightColor: "#00ff59",
    ambientLightColor: "#ffd102",
    pointerColor1: "#d40023",
    pointerColor2: "#000000",
    pointerColor3: "#ffe400",
    textColor: "#009434",
    textNumber: "9",
    index: 29,
    dataCenterX: 1.0,
    dataCenterY: 0.8,
  },
  {
    flagUrl: "uruguayFlag",
    flagName: "flagUruguay",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #ffffff, #ffffff, #54b4e4)",
    teamName: "Uruguay is",
    teamEmoji: "uruguay",
    teamShield: "",
    platformColor: "#00aaff",
    backgroundColor: "#54b4e4",
    shirtColor: "#6499cb",
    shortsColor: "#232323",
    socksColor: "#232323",
    tennisColor: "#1e1b1d",
    shirtNumber: "",
    hairColor: "#3f2210",
    skinColor: "#b17c7e",
    shirtDetailsColor: "#f7f7f7",
    tennisDetailsColor: "#1C1C1C",
    primaryLightColor: "#42a1d5",
    secondaryLightColor: "#882fcb",
    ambientLightColor: "#b7e7ff",
    pointerColor1: "#ffffff",
    pointerColor2: "#54b4e4",
    pointerColor3: "#000000",
    textColor: "#ffffff",
    textNumber: "15",
    index: 30,
    dataCenterX: 0,
    dataCenterY: 1.0,
  },
  {
    flagUrl: "koreaFlag",
    flagName: "flagSouthKorea",
    mainColor: "",
    secondaryColor: "",
    gradientColor: "linear-gradient(to right, #ffffff, #ffffff, #011758)",
    teamName: "South Korea is",
    teamEmoji: "southKorea",
    teamShield: "",
    platformColor: "#ffffff",
    backgroundColor: "#ce1f3c",
    shirtColor: "#ec0e32",
    shortsColor: "#011758",
    socksColor: "#ec0e32",
    tennisColor: "#ffffff",
    shirtNumber: "",
    hairColor: "#1e1b1d",
    skinColor: "#cf9d7c",
    shirtDetailsColor: "#011758",
    tennisDetailsColor: "#868788",
    primaryLightColor: "#c6c6c7",
    secondaryLightColor: "#be0020",
    ambientLightColor: "#e9eeff",
    pointerColor1: "#ec0e32",
    pointerColor2: "#ffffff",
    pointerColor3: "#011758",
    textColor: "#011758",
    textNumber: "7",
    index: 31,
    dataCenterX: 0.2,
    dataCenterY: 1.0,
  },
];
